import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { UserDto } from '../commonTypes/user.types';
import { checkIfAdminOrOwnerOrHr } from '../api/utils/roleUtils';
import { AUTHORIZED_PM_TEAM_LEAD } from '../constants';
import useHttpGetMembersOfLeadsTeamOnMount from './organization/organizationApi/useHttpGetMembersOfLeadsTeamOnMount';

const useCanApproveLeaveRequest = (requesterUserSub: string): boolean => {
    const user = useSelector<RootState, UserDto>(state => state.auth.value);
    const { memberSubs, isReady } = useHttpGetMembersOfLeadsTeamOnMount();

    if (checkIfAdminOrOwnerOrHr(user.role.name)) return true;
    if (AUTHORIZED_PM_TEAM_LEAD.includes(user.role.name)) {
        return isReady && memberSubs.includes(requesterUserSub);
    }

    return false;
};

export default useCanApproveLeaveRequest;
